export default __webpack_public_path__ + "static/media/clouds-cssart.55eac4fb.png";